'use client';

import { trackCtaClicked } from '@/lib/posthog/events';
import { STUDIO_URL, STUDIO_LOGIN_URL, STUDIO_SIGNUP_URL } from '@/lib/urls';

export { STUDIO_URL, STUDIO_LOGIN_URL, STUDIO_SIGNUP_URL };

type CtaLinkProps = {
  location: string;
  label: string;
  href?: string;
  trackLead?: boolean;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;


export function CtaLink({
  location,
  label,
  href = STUDIO_SIGNUP_URL,
  trackLead = false,
  children,
  onClick,
  ...rest
}: CtaLinkProps) {
  return (
    <a
      href={href}
      onClick={(e) => {
        trackCtaClicked(location, label);
        if (trackLead) {
          window.fbq?.('track', 'Lead', { content_name: 'signup' });
        }
        onClick?.(e);
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
